import { AxiosInstance } from 'axios';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => () => {
  return cancellable<string>(
    (cancelOptions: any) => api.get(url, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/content/additional.ts